import { CdkAccordionItem } from '@angular/cdk/accordion';
import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DB_PHASES } from '../../../api/app-types/phase.app';
import { RouteInjection } from '../../../shared/routing/route-injection.class';
import { LvrChip } from '../chip/chip';

@Component({
	selector: 'lvr-assignment-accordion-item',
	templateUrl: './assignment-accordion-item.html',
	styleUrl: './assignment-accordion-item.scss',
	imports: [CdkAccordionItem, MatIcon, LvrChip, MatTooltipModule],
})
export class LvrAssignmentAccordionItem extends RouteInjection {
	public readonly temporary = input<boolean>(false);
	public readonly showToggle = input<boolean>(true);
	public readonly lockOpen = input<boolean>(false);
	public readonly assignmentId = input.required<number>();
	public readonly phaseId = input.required<number>();
	public readonly isServiceOfficeStatement = input<boolean>(false);
	public readonly isAdditionalAssignment = input<boolean>(false);
	public readonly expanded = input<boolean>(false);
	public readonly hideHeader = input<boolean>(false);
	public readonly toggleOnIconOnly = input<boolean>(false);
	public readonly chipLabel = input<string | null>(null);
	public readonly disableTitleNavigation = input<boolean>(false);
	public readonly disableTitleNavigationTooltip = input<string | null>(null);
	public readonly showRestrictionIndicator = computed(
		() => this.disableTitleNavigation() && !!this.disableTitleNavigationTooltip(),
	);

	public toggleAccordion(event: Event, accordion: CdkAccordionItem) {
		if (this.toggleOnIconOnly()) {
			const target = event.target as HTMLElement | null;
			if (!target?.closest('mat-icon')) {
				return;
			}
		}

		event.preventDefault();
		event.stopPropagation();

		if (this.lockOpen() && accordion.expanded) return;

		accordion.toggle();
	}

	public routeToAssignment(event: Event) {
		if (this.disableTitleNavigation()) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}

		if (this.isAdditionalAssignment()) {
			this.router.navigate([this.assignmentId(), 'additional'], { relativeTo: this.route });
			return;
		}
		if (this.phaseId() === DB_PHASES.P0 || (this.phaseId() === DB_PHASES.P1 && !this.temporary())) return;
		if (this.isServiceOfficeStatement()) {
			this.router.navigate([this.assignmentId(), 'fds'], { relativeTo: this.route });
			return;
		}
		this.router.navigate([this.assignmentId()], { relativeTo: this.route });
	}
}
